import { ReactElement } from "react";

// Evergiving
import { CustomFieldConfig } from "@evergiving/common/dist/es2015/form";

// Form components
import { CustomRadioField } from "@/lib/components/CustomRadioField";
import { CustomCheckboxField } from "@/lib/components/CustomCheckboxField";
import { FormField } from "@/lib/components/FormField";
import { SingleSelectField } from "@/lib/components/SingleSelectField";

// Redux
import { VersionedStringFormState } from "@/lib/redux/types";

export function CustomInputField({
  config,
  name,
  htmlName,
}: {
  config: CustomFieldConfig;
  name: keyof VersionedStringFormState;
  htmlName?: string;
}): ReactElement {
  const { fieldType } = config;
  switch (fieldType) {
    case "text":
      return <FormField config={config} name={name} htmlName={htmlName} />;
    case "checkbox":
      return <CustomCheckboxField config={config} name={name} />;
    case "select":
      return <SingleSelectField config={config} name={name} />;
    case "radio":
      return <CustomRadioField config={config} name={name} />;
    default:
      ((x: never) => {
        throw new Error(`Unsupported custom field type ${String(x)}`);
      })(fieldType);
  }
}
